module.exports = __webpack_public_path__ + "pwc.jpg?5912dd0478f5288d4d8118b015235936";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resources/img/pwc.jpg
// module id = 72
// module chunks = 0